import { render, staticRenderFns } from "./UpcomingOrdersView.vue?vue&type=template&id=cb9fcbe4&scoped=true&"
import script from "./UpcomingOrdersView.vue?vue&type=script&lang=js&"
export * from "./UpcomingOrdersView.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingOrdersView.vue?vue&type=style&index=0&id=cb9fcbe4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9fcbe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VIcon,VImg,VSkeletonLoader})
